import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "badgeIntent", "hasBadge", "imageUrl", "shape", "size"];
import * as React from 'react';
import cn from 'classnames';
import { ControlShapeType, Enum, Intent, intentClass } from '../../../library';
var avatarClasses = {
  MAIN: 'avatar',
  BADGE: 'avatar__badge'
};
export var AvatarSize = Enum({
  XSMALL: 'xs',
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  XLARGE: 'xl'
});
export var Avatar = React.forwardRef(function (props, ref) {
  var className = props.className,
    badgeIntent = props.badgeIntent,
    hasBadge = props.hasBadge,
    imageUrl = props.imageUrl,
    shape = props.shape,
    size = props.size,
    popoverEvents = _objectWithoutProperties(props, _excluded);
  var classNames = cn(avatarClasses.MAIN, "-".concat(props.size), "-".concat(props.shape), {
    '-interactive': props.onClick || props.onMouseOver
  }, props.className);
  var badgeClassNames = cn(avatarClasses.BADGE, intentClass(badgeIntent));
  return React.createElement("div", _extends({
    ref: ref,
    className: classNames,
    style: {
      backgroundImage: imageUrl ? "url(".concat(imageUrl, ")") : undefined
    }
  }, popoverEvents), hasBadge ? React.createElement("div", {
    className: badgeClassNames
  }) : null);
});
Avatar.defaultProps = {
  badgeIntent: Intent.DANGER,
  hasBadge: false,
  shape: ControlShapeType.ROUNDED,
  size: AvatarSize.MEDIUM
};